import {matchesSearchText} from '../../utils/searchText';

const cleanSnippetText = (value: any) => String(value ?? '').trim();

const normalizeSnippetNewlines = (value: any) =>
  cleanSnippetText(value).replace(/\r\n?/g, '\n');

const snippetLineCount = (value: string) =>
  value ? value.split('\n').length : 0;

export const plannerEventSummarySnippetInfo = (
  event: any,
  searchQuery: any = '',
) => {
  const headline = normalizeSnippetNewlines(
    event?.summaryText || event?.appointmentSummary,
  );
  const query = cleanSnippetText(searchQuery);
  if (!query) {
    return {
      text: headline,
      lineCount: snippetLineCount(headline),
      matchedLineCount: 0,
    };
  }

  const variants = Array.isArray(event?.summaryVariants)
    ? event.summaryVariants
    : [];
  const matching = variants
    .map((variant: any) => normalizeSnippetNewlines(variant))
    .find((variant: string) => variant && matchesSearchText(variant, query));

  if (!matching) {
    return {
      text: headline,
      lineCount: snippetLineCount(headline),
      matchedLineCount: 0,
    };
  }

  const lineCount = snippetLineCount(matching);

  return {
    text: matching,
    lineCount,
    matchedLineCount: lineCount,
  };
};

export const plannerEventSummarySnippet = (event: any, searchQuery: any = '') =>
  plannerEventSummarySnippetInfo(event, searchQuery).text;
